(function() {
    'use strict';

    var dmsRouteBuilder = function($state:any) {
        var _this = this;

        _this.buildState = function(clientId:any, projectId:any, folderId:any, fileId:any, inTrash:any){
            //Use this for building links to any arbitrary *location* within DMS
            if (inTrash){
                return $state.href('recycleList');
            }

            if (fileId === null){
                if (clientId !== null && clientId.toLowerCase() === 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('templateRootList', {
                            templateId: projectId,
                        });
                    } else {
                        return $state.href('templateFolderList', {
                            templateId: projectId,
                            folderId: folderId
                        });
                    }
                } else if (clientId !== null && clientId.toLowerCase() !== 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('projectRootList', {
                            clientId: clientId,
                            projectId: projectId,
                        });
                    } else {
                        return $state.href('projectFolderList', {
                            clientId: clientId,
                            projectId: projectId,
                            folderId: folderId
                        });
                    }
                } else {
                    return $state.href('folderList', {
                        folderId: folderId
                    });
                }
            } else { //Use this for building links to any arbitrary *file* within DMS.
                if (clientId !== null && clientId.toLowerCase() === 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('templateRootFileView', {
                            templateId: projectId,
                            fileId: fileId
                        });
                    } else {
                        return $state.href('templateFileView', {
                            templateId: projectId,
                            folderId: folderId,
                            fileId: fileId
                        });
                    }
                } else if (clientId !== null && clientId.toLowerCase() !== 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('projectRootFileView', {
                            clientId: clientId,
                            projectId: projectId,
                            fileId: fileId
                        });
                    } else {
                        return $state.href('projectFileView', {
                            clientId: clientId,
                            projectId: projectId,
                            folderId: folderId,
                            fileId: fileId
                        });
                    }
                } else {
                    return $state.href('folderFileView', {
                        folderId: folderId,
                        fileId: fileId
                    });
                }
            }
        };
    };

    dmsRouteBuilder.$inject = ['$state'];
    angular.module('onvio.documents').service('dmsRouteBuilder', dmsRouteBuilder);
}());
